define("shared/components/shared/plan-recommendation/plan-card", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@ember/template", "@glimmer/component", "ember-concurrency", "shared/types/plans", "shared/utils/plan-card", "shared/utils/plan-rec-analytics", "shared/utils/plan-route", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _template, _component2, _emberConcurrency, _plans, _planCard, _planRecAnalytics, _planRoute, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@ember/template",0,"@glimmer/component",0,"ember-concurrency",0,"shared/types/plans",0,"shared/utils/plan-card",0,"shared/utils/plan-rec-analytics",0,"shared/utils/plan-route",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class="cPR--planCard"
    data-test-id="plan-recommendation-plan-card"
    data-test-tier={{@recommendation.tier}}
    ...attributes
  >
    <h1 class="cPR--planCard__headline" data-test-id="plan-recommendation-plan-card-headline">
      {{this.headline}}
    </h1>
  
    <p class="cPR--planCard__description" data-test-id="plan-recommendation-plan-card-description">
      {{this.description}}
    </p>
  
    <h2 class="cPR--planCard__offersLabel" data-test-id="plan-recommendation-plan-card-offers-label">
      {{t this.card.offersLabel.key planName=(t this.card.offersLabel.params.planName)}}
    </h2>
  
    <ul class="cPR--planCard__callouts">
      {{#each this.card.callouts as |callout|}}
        <li
          class="cPR--planCard__callout"
          data-test-id="plan-recommendation-plan-card-callout"
          data-test-tag={{callout.tag}}
        >
          {{! Decorative: the tag and copy beside it already carry the meaning. }}
          {{svg-jar (get this.calloutIcon callout.tag) aria-hidden="true" class="cPR--planCard__calloutIcon"}}
          <span class="cPR--planCard__calloutText">
            <span class="cPR--planCard__calloutTag">{{t callout.tagKey}}</span>
            <span class="cPR--planCard__calloutCopy">{{t callout.copyKey}}</span>
          </span>
        </li>
      {{/each}}
    </ul>
  
    {{! Scale has no rule and no alternative: the footnote leads straight into See all plans (Figma 34230-154006). }}
    <div
      class="cPR--planCard__footnote {{unless this.card.alternative 'cPR--planCard__footnote--last'}}"
      data-test-id="plan-recommendation-plan-card-footnote"
    >
      {{t "onboarding.plan_card.footnote.intro"}}
      <ul class="cPR--planCard__footnoteList">
        {{#each this.card.footnoteKeys as |key|}}
          <li data-test-id="plan-recommendation-plan-card-footnote-item">{{t key}}</li>
        {{/each}}
      </ul>
      <p class="cPR--planCard__afterTrial" data-test-id="plan-recommendation-plan-card-after-trial">
        {{t "onboarding.plan_card.footnote.after_trial"}}
      </p>
    </div>
  
    {{#if this.card.alternative}}
      <hr class="cPR--planCard__divider" />
      <p class="cPR--planCard__alternative" data-test-id="plan-recommendation-plan-card-alternative">
        <span class="cPR--planCard__alternativePrompt">
          {{t this.card.alternative.prompt.key planName=(t this.card.alternative.prompt.params.planName)}}
        </span>
        <span class="cPR--planCard__alternativeCondition">{{t this.card.alternative.conditionKey}}</span>
      </p>
    {{/if}}
  
    {{! A detour: nothing here marks the walk complete, so the user can browse the picker and come back. }}
    <p class="cPR--planCard__seeAllPlans" data-test-id="plan-recommendation-plan-card-see-all-plans">
      <Shared::Ui::Button
        @promise={{this.openTrialPlans}}
        @text={{t "onboarding.plan_card.see_all_plans"}}
        @variant="actionLink"
        class="cPR--planCard__seeAllPlansLink"
        data-test-id="plan-recommendation-plan-card-see-all-plans-link"
      />
    </p>
  
    {{! The button drops repeat clicks and disables itself while @promise runs. }}
    <Shared::Ui::Button
      @additional="block"
      @promise={{this.openCheckout}}
      @text={{t this.card.cta.key planName=(t this.card.cta.params.planName)}}
      @variant="primary"
      class="cPR--planCard__cta"
      data-test-id="plan-recommendation-plan-card-cta"
    />
  
    <p class="cPR--planCard__price" data-test-id="plan-recommendation-plan-card-price">
      {{#if this.yearlyPrice}}
        <span data-test-id="plan-recommendation-plan-card-price-amount">
          {{t "onboarding.plan_card.price" amount=this.yearlyPrice.amount}}
        </span>
        <span aria-hidden="true">•</span>
        <span class="cPR--planCard__priceOffer">
          {{t "onboarding.plan_card.offer" percent=this.yearlyPrice.discountPercent}}
        </span>
      {{else}}
        <span class="cPR--planCard__priceOffer">
          {{t "onboarding.plan_card.months_free"}}
        </span>
      {{/if}}
    </p>
  </div>
  */
  {
    "id": "dZXPQhpB",
    "block": "[[[11,0],[24,0,\"cPR--planCard\"],[24,\"data-test-id\",\"plan-recommendation-plan-card\"],[16,\"data-test-tier\",[30,1,[\"tier\"]]],[17,2],[12],[1,\"\\n  \"],[10,\"h1\"],[14,0,\"cPR--planCard__headline\"],[14,\"data-test-id\",\"plan-recommendation-plan-card-headline\"],[12],[1,\"\\n    \"],[1,[30,0,[\"headline\"]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,2],[14,0,\"cPR--planCard__description\"],[14,\"data-test-id\",\"plan-recommendation-plan-card-description\"],[12],[1,\"\\n    \"],[1,[30,0,[\"description\"]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,\"h2\"],[14,0,\"cPR--planCard__offersLabel\"],[14,\"data-test-id\",\"plan-recommendation-plan-card-offers-label\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[[30,0,[\"card\",\"offersLabel\",\"key\"]]],[[\"planName\"],[[28,[37,0],[[30,0,[\"card\",\"offersLabel\",\"params\",\"planName\"]]],null]]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,\"ul\"],[14,0,\"cPR--planCard__callouts\"],[12],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,0,[\"card\",\"callouts\"]]],null]],null],null,[[[1,\"      \"],[10,\"li\"],[14,0,\"cPR--planCard__callout\"],[14,\"data-test-id\",\"plan-recommendation-plan-card-callout\"],[15,\"data-test-tag\",[30,3,[\"tag\"]]],[12],[1,\"\\n\"],[1,\"        \"],[1,[28,[35,3],[[28,[37,4],[[30,0,[\"calloutIcon\"]],[30,3,[\"tag\"]]],null]],[[\"aria-hidden\",\"class\"],[\"true\",\"cPR--planCard__calloutIcon\"]]]],[1,\"\\n        \"],[10,1],[14,0,\"cPR--planCard__calloutText\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"cPR--planCard__calloutTag\"],[12],[1,[28,[35,0],[[30,3,[\"tagKey\"]]],null]],[13],[1,\"\\n          \"],[10,1],[14,0,\"cPR--planCard__calloutCopy\"],[12],[1,[28,[35,0],[[30,3,[\"copyKey\"]]],null]],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[3]],null],[1,\"  \"],[13],[1,\"\\n\\n\"],[1,\"  \"],[10,0],[15,0,[29,[\"cPR--planCard__footnote \",[52,[51,[30,0,[\"card\",\"alternative\"]]],\"cPR--planCard__footnote--last\"]]]],[14,\"data-test-id\",\"plan-recommendation-plan-card-footnote\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"onboarding.plan_card.footnote.intro\"],null]],[1,\"\\n    \"],[10,\"ul\"],[14,0,\"cPR--planCard__footnoteList\"],[12],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,0,[\"card\",\"footnoteKeys\"]]],null]],null],null,[[[1,\"        \"],[10,\"li\"],[14,\"data-test-id\",\"plan-recommendation-plan-card-footnote-item\"],[12],[1,[28,[35,0],[[30,4]],null]],[13],[1,\"\\n\"]],[4]],null],[1,\"    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"cPR--planCard__afterTrial\"],[14,\"data-test-id\",\"plan-recommendation-plan-card-after-trial\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"onboarding.plan_card.footnote.after_trial\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"card\",\"alternative\"]],[[[1,\"    \"],[10,\"hr\"],[14,0,\"cPR--planCard__divider\"],[12],[13],[1,\"\\n    \"],[10,2],[14,0,\"cPR--planCard__alternative\"],[14,\"data-test-id\",\"plan-recommendation-plan-card-alternative\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"cPR--planCard__alternativePrompt\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[[30,0,[\"card\",\"alternative\",\"prompt\",\"key\"]]],[[\"planName\"],[[28,[37,0],[[30,0,[\"card\",\"alternative\",\"prompt\",\"params\",\"planName\"]]],null]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[14,0,\"cPR--planCard__alternativeCondition\"],[12],[1,[28,[35,0],[[30,0,[\"card\",\"alternative\",\"conditionKey\"]]],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[1,\"  \"],[10,2],[14,0,\"cPR--planCard__seeAllPlans\"],[14,\"data-test-id\",\"plan-recommendation-plan-card-see-all-plans\"],[12],[1,\"\\n    \"],[8,[39,7],[[24,0,\"cPR--planCard__seeAllPlansLink\"],[24,\"data-test-id\",\"plan-recommendation-plan-card-see-all-plans-link\"]],[[\"@promise\",\"@text\",\"@variant\"],[[30,0,[\"openTrialPlans\"]],[28,[37,0],[\"onboarding.plan_card.see_all_plans\"],null],\"actionLink\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[1,\"  \"],[8,[39,7],[[24,0,\"cPR--planCard__cta\"],[24,\"data-test-id\",\"plan-recommendation-plan-card-cta\"]],[[\"@additional\",\"@promise\",\"@text\",\"@variant\"],[\"block\",[30,0,[\"openCheckout\"]],[28,[37,0],[[30,0,[\"card\",\"cta\",\"key\"]]],[[\"planName\"],[[28,[37,0],[[30,0,[\"card\",\"cta\",\"params\",\"planName\"]]],null]]]],\"primary\"]],null],[1,\"\\n\\n  \"],[10,2],[14,0,\"cPR--planCard__price\"],[14,\"data-test-id\",\"plan-recommendation-plan-card-price\"],[12],[1,\"\\n\"],[41,[30,0,[\"yearlyPrice\"]],[[[1,\"      \"],[10,1],[14,\"data-test-id\",\"plan-recommendation-plan-card-price-amount\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"onboarding.plan_card.price\"],[[\"amount\"],[[30,0,[\"yearlyPrice\",\"amount\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[14,\"aria-hidden\",\"true\"],[12],[1,\"•\"],[13],[1,\"\\n      \"],[10,1],[14,0,\"cPR--planCard__priceOffer\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"onboarding.plan_card.offer\"],[[\"percent\"],[[30,0,[\"yearlyPrice\",\"discountPercent\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,1],[14,0,\"cPR--planCard__priceOffer\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"onboarding.plan_card.months_free\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@recommendation\",\"&attrs\",\"callout\",\"key\"],false,[\"t\",\"each\",\"-track-array\",\"svg-jar\",\"get\",\"unless\",\"if\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/plan-recommendation/plan-card.hbs",
    "isStrictMode": false
  });
  /**
   * Callout tag -> `svg-jar` asset name, matched glyph-for-glyph against the three card frames
   * (Figma 33689-81499, 33689-83683, 33689-82153).
   *
   * `analyze` and `benchmark` must never resolve to the same asset: five of the six Scale rows in
   * `CALLOUT_ORDER` put both on one card, and a repeated glyph reads as a bug.
   */
  const CALLOUT_ICON = {
    plan: 'image',
    publish: 'calendar',
    approve: 'approved',
    engage: 'social-inbox',
    analyze: 'insights',
    benchmark: 'custom-analytics',
    monitor: 'social-listening'
  };
  let PlanCardComponent = _exports.default = (_class = class PlanCardComponent extends _component2.default {
    constructor(owner, args) {
      var _this;
      super(owner, args);
      _this = this;
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "plans", _descriptor4, this);
      _initializerDefineProperty(this, "router", _descriptor5, this);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor6, this);
      _initializerDefineProperty(this, "segment", _descriptor7, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor8, this);
      /**
       * A field initializer runs once per instance, matching how the terminal slide scores: a getter
       * would re-assemble the whole card on every re-render.
       */
      _defineProperty(this, "card", (0, _planCard.buildPlanCard)(this.args.recommendation.tier, this.args.answers));
      /** Exposed for the template's `{{get}}` lookup; the callouts themselves stay the module's own. */
      _defineProperty(this, "calloutIcon", CALLOUT_ICON);
      /** The card renders without its price line until this resolves, and stays without it if it never does. */
      _defineProperty(this, "loadPlans", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            yield this.subscriptions.getAllSubscriptionPlans();
          } catch (error) {
            this.errors.log(error);
          }
        }
      }), {
        drop: true
      }, "loadPlans", null));
      /**
       * `drop` because `openCheckoutModal` reloads the subscription and the account before the modal
       * appears, and a second click during that gap would run the whole sequence again. The button
       * disables itself for as long as this is running, which is why the service has to return its
       * promise rather than fire the reloads and forget them.
       *
       * `PlanInterval.Yearly` is what makes the card's `billed yearly` quote true rather than hoped-for.
       */
      _defineProperty(this, "openCheckout", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.didConvert = false;
          this.segment.track(_planRecAnalytics.PLAN_REC_EVENTS.clickedCta, this.analyticsPayload);
          yield this.seamlessCheckoutManager.openCheckoutModal(this.args.recommendation.planType, {
            interval: _plans.PlanInterval.Yearly,
            location: 'plan_recommendation',
            onCloseOrSuccess: this.finishCheckout,
            onSuccessModalClose: this.routeToDestination,
            successCallback: this.recordConversion,
            trialStartLocation: 'plan recommendation'
          });
          this.planTypeAtOpen = this.subscriptions.subscriptionPlan?.planType;
        }
      }), {
        drop: true
      }, "openCheckout", null));
      /**
       * The paid path fires `successCallback` at transaction complete and only later closes, so the
       * conversion is recorded the moment it happens — a user who closes the tab on the success modal
       * still produces it — and the close handler knows which outcome it is reporting.
       */
      _defineProperty(this, "didConvert", false);
      /** The sourceless trial behind the checkout's Back button closes without firing `successCallback`. */
      _defineProperty(this, "planTypeAtOpen", void 0);
      /**
       * The success hook fires before the subscription reloads, so the plan comes from the checkout that
       * sold it; the picker overwrites that when the user chooses another plan.
       */
      _defineProperty(this, "recordConversion", function () {
        let purchasedPlanType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.seamlessCheckoutManager.selectedPlanType;
        _this.didConvert = true;
        const payload = {
          ..._this.analyticsPayload,
          'purchased-plan-type': purchasedPlanType ?? _this.args.recommendation.planType
        };
        _this.segment.track(_planRecAnalytics.PLAN_REC_EVENTS.converted, payload);
      });
      /** Both outcomes close through here and land on the same route, so this event is what tells them apart. */
      _defineProperty(this, "finishCheckout", () => {
        const purchasedPlanType = this.subscriptions.subscriptionPlan?.planType;
        if (!this.didConvert && purchasedPlanType !== this.planTypeAtOpen) {
          this.recordConversion(purchasedPlanType);
        } else if (!this.didConvert) {
          this.segment.track(_planRecAnalytics.PLAN_REC_EVENTS.abandoned, this.analyticsPayload);
        }
        this.args.onCheckoutClose();
      });
      /**
       * No `onCloseOrSuccess`: closing the picker returns the user to this card rather than ending the walk.
       */
      _defineProperty(this, "openTrialPlans", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.segment.track(_planRecAnalytics.PLAN_REC_EVENTS.clickedSeeAllPlans, this.analyticsPayload);
          yield this.seamlessCheckoutManager.openTrialPlansModal({
            location: 'plan_recommendation',
            trialStartLocation: 'plan recommendation'
          });
        }
      }), {
        drop: true
      }, "openTrialPlans", null));
      /**
       * Only a paid checkout shows the success modal, so an abandoned one ends the walk and stays put.
       * Cluster routes take the group slug explicitly: `/mobile` has no active cluster route to inherit it from.
       */
      _defineProperty(this, "routeToDestination", () => {
        const route = (0, _planRoute.resolveDestination)(this.args.answers);
        if (!route.startsWith('cluster.')) {
          this.router.transitionTo(route);
          return;
        }
        const slug = this.auth.lastGroup?.slug;
        if (slug) {
          this.router.transitionTo(route, slug);
        }
      });
      this.loadPlans.perform();
    }
    /** The same fields the plan picker reads, so the two prices a user can compare agree. */
    get yearlyPrice() {
      const plan = this.plans.getPlan(this.args.recommendation.planType, false);
      if (!plan?.monthlyPriceBilledYearly || !plan.yearlyDiscountPercent) {
        return undefined;
      }
      return {
        amount: (plan.monthlyPriceBilledYearly / 100).toFixed(2),
        discountPercent: plan.yearlyDiscountPercent
      };
    }

    /** The design colours the plan name; the name is our own translation, never user input. */
    get headline() {
      const {
        key,
        params
      } = this.card.headline;
      const planName = `<span class="cPR--planCard__planName">${this.intl.t(params.planName)}</span>`;
      return (0, _template.htmlSafe)(this.intl.t(key, {
        planName
      }));
    }

    /**
     * The one field the template cannot resolve itself. Its params are absent for every question the
     * user skipped, and a subexpression like `(if params.q1Phrase (t params.q1Phrase))` does not
     * help — Handlebars evaluates both branches, so the absent ones still reach `t` as undefined.
     *
     * Resolving here keeps the alternative — eight `{{#if}}` arms, one per answered set — out of the
     * template. The copy still comes wholly from the copy module; this only looks up its keys.
     */
    get description() {
      const {
        key,
        params
      } = this.card.description;
      const resolved = {};
      if (params.q1Phrase !== undefined) {
        resolved.q1Phrase = this.intl.t(params.q1Phrase);
      }
      if (params.q2Range !== undefined) {
        resolved.q2Range = this.intl.t(params.q2Range);
      }
      if (params.q3Goal !== undefined) {
        resolved.q3Goal = this.intl.t(params.q3Goal);
      }
      if (params.valueSentence !== undefined) {
        resolved.valueSentence = this.intl.t(params.valueSentence.key, {
          planName: this.intl.t(params.valueSentence.params.planName)
        });
      }
      return (0, _template.htmlSafe)(this.intl.t(key, resolved));
    }
    /** Every card event carries what was recommended, so each can be joined to the shown event without relying on it. */
    get analyticsPayload() {
      return (0, _planRecAnalytics.buildRecommendationPayload)(this.args.recommendation, this.args.answers);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PlanCardComponent);
});